import { io, Socket } from "socket.io-client";

// const SOCKET_URL = "http://localhost:3000";
const SOCKET_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000";
// Type the socket with generics if needed
export const rankingSocket: Socket = io(`${SOCKET_URL}/ranking`, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

rankingSocket.on("connect", () => {
  console.log("✅ Connected to ranking socket:", rankingSocket.id);
});

rankingSocket.on("disconnect", () => {
  console.log("❌ Disconnected from ranking socket");
});
